<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Расписание работы</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="raspisanie-raboty"
            class="typography__headline2"
          >
            Расписание работы
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Расписание работы&raquo;.</p>

            <p>Работа с&nbsp;расписанием возможна только если заполнены данные <BaseLink target="_blank" to="/faq/articles/kontakty-i-dannye-filialov">филиалов</BaseLink>

             и&nbsp;<BaseLink target="_blank" to="/faq/articles/spisok-sotrudnikov-i-ikh-dannye">сотрудников</BaseLink>.</p>

            <p>
              Раздел позволяет увидеть и&nbsp;точечно отредактировать рабочее расписание всех сотрудников во&nbsp;всех
              филиалах в&nbsp;одном удобном месте.
            </p>

            <p>
              При заходе будет видно расписание всех нужных сотрудников по&nbsp;нужным филиалам за&nbsp;текущую неделю.
            </p>

            <p>
              В&nbsp;контроллах сверху можно переключить неделю вперед или назад, а&nbsp;по&nbsp;нажатию
              &laquo;Сегодня&raquo; быстро переместиться к&nbsp;текущей неделе.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/raspisaniye-raboty-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>Нажав сверху на&nbsp;иконку со&nbsp;стрелочкой откроется календарь и&nbsp;фильтры.</p>

            <p>
              В&nbsp;календаре выделены дни выбранной сейчас недели. По&nbsp;нажатию на&nbsp;нужный день можно быстро
              переключиться на&nbsp;другую неделю.
            </p>

            <p>
              В&nbsp;фильтрах можно настроить показ расписания только по&nbsp;определенным адресам и&nbsp;сотрудникам.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/raspisaniye-raboty-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="izmenenie-raspisaniya"
            class="typography__headline2"
          >
            Изменение расписания
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              По&nbsp;нажатию на&nbsp;нужную ячейку можно точечно отредактировать расписание сотрудника на&nbsp;этот
              конкретный день.
            </p>

            <p>
              В&nbsp;этом случае оно будет отличаться от&nbsp;его базового расписания и&nbsp;посмотреть после
              редактирования актуальное расписание на&nbsp;этот день можно будет только здесь.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/raspisaniye-raboty-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>В&nbsp;появившемся окне будет вся информация по&nbsp;его текущему расписанию на&nbsp;этот день.</p>

            <p>При необходимости измените данные и&nbsp;нажмите &laquo;Сохранить&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/raspisaniye-raboty-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>После сохранения изменений данные в&nbsp;расписании обновятся.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/raspisaniye-raboty-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С&nbsp;сотрудниками разобрались. Самое время перейти к&nbsp;настройке  <BaseLink
            target="_blank"
            to="/faq/articles/dobavleniye-i-redaktirovaniye-uslugi"
          >услуг</BaseLink>
 и
            <BaseLink
              target="_blank"
              to="/faq/categories/onlayn-zapis"
              >онлайн-записи</BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Сотрудники",
    url: "/faq/categories/sotrudniki",
  },
  {
    name: "Расписание работы",
  },
];

const menu = [
  {
    name: "Расписание&nbsp;работы",
    url: "raspisanie-raboty",
  },
  {
    name: "Изменение&nbsp;расписания",
    url: "izmenenie-raspisaniya",
  },
];

const relatedArticles = [
  {
    name: "Добавление и&nbsp;редактирование сотрудника",
    slug: "dobavleniye-i-redaktirovaniye-sotrudnika",
  },
  {
    name: "Список сотрудников и&nbsp;их данные",
    slug: "spisok-sotrudnikov-i-ikh-dannye",
  },
  {
    name: "Уведомления сотрудника",
    slug: "uvedomleniya-sotrudnika",
  },
];

useSeoMeta({
  title: "Расписание работы",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

p a {
  display: contents;
}
</style>
